import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from '../../plugins/vuetify'
import '@babel/polyfill'

import VueLazyload from 'vue-lazyload'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

window.axios = require('axios');

Vue.use(VueAwesomeSwiper /* { default global options } */)
Vue.use(VueLazyload, {
  preLoad: 1.3,
  attempt: 1,
})
Vue.component('Loading', VueLoading)

new Vue({
  router,
  vuetify,
  render: h => h(App),
}).$mount('#app')
